define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MLandDegradationDomain = void 0;
    class MLandDegradationDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MLandDegradationDomain.Scald, value: "Scald" },
                    { key: MLandDegradationDomain.ErosionGully, value: "Erosion (gully)" },
                    { key: MLandDegradationDomain.ErosionHillslope, value: "Erosion (hillslope)" },
                    { key: MLandDegradationDomain.ErosionPedestal, value: "Erosion (pedestal)" },
                    { key: MLandDegradationDomain.ErosionStreamBank, value: "Erosion (stream bank)" },
                    { key: MLandDegradationDomain.ExposedSubSoil, value: "Exposed sub-soil" },
                    { key: MLandDegradationDomain.SandDrift, value: "Sand drift" },
                    { key: MLandDegradationDomain.Salinity, value: "Salinity" },
                    { key: MLandDegradationDomain.RiparianAreaDisturbance, value: "Riparian area disturbance" },
                    { key: MLandDegradationDomain.BlowingDust, value: "Blowing dust" },
                    { key: MLandDegradationDomain.StockPressure, value: "Stock pressure" },
                    { key: MLandDegradationDomain.Other, value: "Other" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MLandDegradationDomain.Scald] = 0;
                this.KeyIndex[MLandDegradationDomain.ErosionGully] = 1;
                this.KeyIndex[MLandDegradationDomain.ErosionHillslope] = 2;
                this.KeyIndex[MLandDegradationDomain.ErosionPedestal] = 3;
                this.KeyIndex[MLandDegradationDomain.ErosionStreamBank] = 4;
                this.KeyIndex[MLandDegradationDomain.ExposedSubSoil] = 5;
                this.KeyIndex[MLandDegradationDomain.SandDrift] = 6;
                this.KeyIndex[MLandDegradationDomain.Salinity] = 7;
                this.KeyIndex[MLandDegradationDomain.RiparianAreaDisturbance] = 8;
                this.KeyIndex[MLandDegradationDomain.BlowingDust] = 9;
                this.KeyIndex[MLandDegradationDomain.StockPressure] = 10;
                this.KeyIndex[MLandDegradationDomain.Other] = 11;
                this.ValueIndex = {};
                this.ValueIndex["Scald"] = 0;
                this.ValueIndex["Erosion (gully)"] = 1;
                this.ValueIndex["Erosion (hillslope)"] = 2;
                this.ValueIndex["Erosion (pedestal)"] = 3;
                this.ValueIndex["Erosion (stream bank)"] = 4;
                this.ValueIndex["Exposed sub-soil"] = 5;
                this.ValueIndex["Sand drift"] = 6;
                this.ValueIndex["Salinity"] = 7;
                this.ValueIndex["Riparian area disturbance"] = 8;
                this.ValueIndex["Blowing dust"] = 9;
                this.ValueIndex["Stock pressure"] = 10;
                this.ValueIndex["Other"] = 11;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MLandDegradationDomain = MLandDegradationDomain;
    Object.defineProperty(MLandDegradationDomain, "Scald", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(MLandDegradationDomain, "ErosionGully", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MLandDegradationDomain, "ErosionHillslope", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MLandDegradationDomain, "ErosionPedestal", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MLandDegradationDomain, "ErosionStreamBank", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MLandDegradationDomain, "ExposedSubSoil", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MLandDegradationDomain, "SandDrift", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MLandDegradationDomain, "Salinity", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(MLandDegradationDomain, "RiparianAreaDisturbance", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(MLandDegradationDomain, "BlowingDust", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 9
    });
    Object.defineProperty(MLandDegradationDomain, "StockPressure", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(MLandDegradationDomain, "Other", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 99
    });
    Object.defineProperty(MLandDegradationDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
